//ADD PACKAGE
export const ADD_PROFESSION_REQUEST = "ADD_PACKAGE_REQUEST";
export const ADD_PROFESSION_SUCCESS = "ADD_PACKAGE_SUCCESS";
export const ADD_PROFESSION_FAILURE = "ADD_PACKAGE_FAILURE";

//UPDATE PACKAGE
export const UPDATE_PROFESSION_REQUEST = "UPDATE_PACKAGE_REQUEST";
export const UPDATE_PROFESSION_SUCCESS = "UPDATE_PACKAGE_SUCCESS";
export const UPDATE_PROFESSION_FAILURE = "UPDATE_PACKAGE_FAILURE";

//DELETE PACKAGE
export const DELETE_PROFESSION_REQUEST = "DELETE_PACKAGE_REQUEST";
export const DELETE_PROFESSION_SUCCESS = "DELETE_PACKAGE_SUCCESS";
export const DELETE_PROFESSION_FAILURE = "DELETE_PACKAGE_FAILURE";

//GET PACKAGE LIST
export const GET_PROFESSION_REQUEST = "GET_PACKAGE_REQUEST";
export const GET_PROFESSION_SUCCESS = "GET_PACKAGE_SUCCESS";
export const GET_PROFESSION_FAILURE = "GET_PACKAGE_FAILURE";
